import { useState, VFC } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { deleteContributionSearchConditions } from 'src/api/contribution'
import { asModal } from 'src/components/hoc/asModal'
import { ContributionSearchConditionsData } from 'src/models/Contribution'
import {
  trueblack,
  truewhite,
  _contributionsBackground,
  _contributiontext,
  _formalert,
  _profilegreen,
  _profileoverlay,
} from 'src/styles/colors'
import styled, { css } from 'styled-components'
import { inversing } from '../../styles/mixins'

export type FilterDeleteModalViewProps = {
  close: VoidFunction
  searchCondition: ContributionSearchConditionsData | undefined
  onClickFetchContributionSearchConditions: (isCreate: boolean) => void
}

const FilterDeleteModalView: VFC<FilterDeleteModalViewProps> = ({
  close,
  searchCondition,
  onClickFetchContributionSearchConditions,
}) => {
  const { handleSubmit } = useForm<any>({})
  const [errorMessages, setErrorMessages] = useState<string[]>([])

  const handleOnSubmit: SubmitHandler<any> = async () => {
    if (!searchCondition) return

    const res = await deleteContributionSearchConditions(searchCondition?.id)
    if (res.error?.errorMessages) {
      setErrorMessages(res.error.errorMessages)
      return
    }
    setErrorMessages([])
    onClickFetchContributionSearchConditions(false)
    close()
  }

  return (
    <StyledForm onSubmit={handleSubmit(handleOnSubmit)}>
      <Layout>
        <Body>
          <FilterDeleteModalHeader>
            <FilterDeleteModalHeaderTitle>
              このフィルタを削除しますか？
            </FilterDeleteModalHeaderTitle>
            <FilterDeleteModalHeaderTitleMessage>
              一度削除されたフィルタは復元できません
            </FilterDeleteModalHeaderTitleMessage>
          </FilterDeleteModalHeader>
          <FilterTitleHeader>
            <FilterTitle>フィルタ名</FilterTitle>
          </FilterTitleHeader>
          <FilterParamTable>
            <FilterTitleLabel>{searchCondition?.title}</FilterTitleLabel>
            <FilterParamButton>
              <CancelButton type="button" onClick={close}>
                キャンセル
              </CancelButton>
              <FilterDeleteButton type="submit">削除する</FilterDeleteButton>
            </FilterParamButton>
            <Alert>
              {errorMessages.length > 0 && (
                <p>
                  {errorMessages.map((message) => (
                    <p key={message}>{message}</p>
                  ))}
                </p>
              )}
            </Alert>
          </FilterParamTable>
        </Body>
      </Layout>
    </StyledForm>
  )
}

const modalOverlayStyle = css`
  backdrop-filter: blur(6px) brightness(0.5);
  background-color: ${_profileoverlay}80;
`

export const FilterDeleteModal = asModal(FilterDeleteModalView, {
  overlayStyle: modalOverlayStyle,
  scrollable: true,
})

const StyledForm = styled.form``

const Layout = styled.div`
  width: 496px;
  box-shadow: 0 5px 15px ${trueblack}80;
  border-radius: 5px;
`

const Body = styled.div`
  background: ${truewhite};
  padding: 32px;
  border-radius: 5px;
`

const FilterDeleteModalHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 16px;
  font-weight: 700;
`

const FilterDeleteModalHeaderTitle = styled.div``
const FilterDeleteModalHeaderTitleMessage = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: #393e4c;
  margin-top: 8px;
`

const FilterTitleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 700;
`
const FilterTitle = styled.div`
  color: ${_profilegreen};
`

const FilterTitleLabel = styled.label`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const FilterParamTable = styled.div`
  display: flex;
  flex-direction: column;
`

const FilterParamButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 40px;
`

const CancelButton = styled.button`
  display: block;
  color: ${_profilegreen};
  width: 200px;
  padding: 10px 0;
  border-radius: 5px;
  text-align: center;
  background: ${_contributionsBackground};

  ${inversing({
    color: _contributiontext,
    background: _contributionsBackground,
  })};
`

const FilterDeleteButton = styled.button`
  display: block;
  color: ${truewhite};
  width: 200px;
  padding: 16px 0;
  margin-left: 24px;
  border-radius: 5px;
  text-align: center;

  ${inversing({ color: '#D90A0A', background: '#FCE9EA' })};

  @media screen and (max-width: 540px) {
    margin-left: 0px;
  }
`
const Alert = styled.div`
  color: ${_formalert};
  margin-bottom: 15px;
  p {
    text-align: center;
  }
`
